/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import intermoji from '@intercom/intermoji';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { SkinToneModifiers } from '@intercom/embercom-prosemirror-composer/lib/config/composer-config';
export function substituteColonifiedForUnicode(string) {
  return intermoji.splitOnUnicodeEmojis(string).reduce(function (prev, item) {
    return prev += intermoji.isSupportedUnicode(item) ? wrapInColons(intermoji.identifierFromUnicode(item)) : item;
  }, '');
}
let _hasNativeEmojiSupport;
export function hasNativeEmojiSupport() {
  if (_hasNativeEmojiSupport === undefined) {
    _hasNativeEmojiSupport = intermoji.hasNativeSupport(document);
  }
  return _hasNativeEmojiSupport;
}
export function substituteUnicodeForColonified(text) {
  return intermoji.substituteUnicodeForColonified(text);
}
export function wrapInColons(string) {
  return `:${string}:`;
}
let emojiItems = [];
export function getEmojiItemList(skinToneModifier = SkinToneModifiers.NoSkinToneModifier, rebuild = false) {
  if (rebuild) {
    emojiItems = [];
  }
  if (emojiItems.length === 0) {
    intermoji.prettyEmoticonsIdentifierList().sort().map(identifier => {
      let unicodeIcon = intermoji.unicodeFromIdentifier(identifier);
      if (intermoji.isEmojiBaseUnicode(unicodeIcon) && !intermoji.isUglyNativeEmoji(unicodeIcon)) {
        let display = sanitizeHtml(applySkinTone(unicodeIcon, skinToneModifier));
        if (!hasNativeEmojiSupport()) {
          display = sanitizeHtml(intermoji.fallbackImage(16, display, 'emoji-fallback-image'));
        }
        emojiItems.push({
          identifier,
          unicodeIcon,
          display
        });
      }
    });
  }
  return emojiItems;
}
export function applySkinTone(unicodeIcon, skinToneModifier) {
  if (skinToneModifier === undefined || skinToneModifier === SkinToneModifiers.NoSkinToneModifier) {
    return unicodeIcon;
  }
  let modifiedEmojis = intermoji.getAllModifiedForBaseEmoji(unicodeIcon);
  if (modifiedEmojis.length === 0) {
    return unicodeIcon;
  }
  let matchedSkinToneModifiedEmojis = modifiedEmojis.filter(modifiedEmoji => {
    return Array.from(modifiedEmoji).some(element => element.codePointAt(0) === skinToneModifier);
  });
  return matchedSkinToneModifiedEmojis.length === 1 ? matchedSkinToneModifiedEmojis[0] : unicodeIcon;
}

// These two functions are just for use in tests
export function disableNativeEmojiSupport() {
  _hasNativeEmojiSupport = false;
  getEmojiItemList(SkinToneModifiers.NoSkinToneModifier, true);
}
export function enableNativeEmojiSupport() {
  _hasNativeEmojiSupport = true;
  getEmojiItemList(SkinToneModifiers.NoSkinToneModifier, true);
}